export default __webpack_public_path__ + "static/subscription-management-187d15297fcd1e98f39a9f46528091bd.svg";